import { useSnackbar } from 'notistack';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { getResponseMessage } from '../../../../../../utils/utils';
import { IProduct } from '../../../../../../interfaces/product';
import { getOffers } from '../../../../../../crud/offer.crud';

export type Offer = {
  company_id: number;
  delivery_period: number;
  id: number;
  order_quantity: number;
  prices: {
    price: number;
    amount: number;
  }[];
  product: IProduct;
  product_id: number;
  status: 'moderation' | 'active' | 'deleted';
  stock_quantity: number;
  quantity_level?: 'little' | 'medium' | 'much';
  second_quantity_level?: 'little' | 'medium' | 'much';
};

export const useGetOffers = () => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const [loadingOffers, setLoading] = useState(false);
  const [offers, setOffers] = useState<Offer[] | null>(null);
  const [page, setPage] = useState({ page: 1, perPage: 20, total: 0, total_pages: 0 });

  const fetchOffers = useCallback(
    async (data: {
      company_id?: number;
      product_id?: number;
      status?: 'moderation' | 'active' | 'deleted';
      new_status?: 'moderation' | 'active' | 'deleted';
      page?: number;
      per_page?: number;
    }) => {
      setLoading(true);
      getOffers(data)
        .then((res: any) => {
          setOffers(res.data.data);
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const { page, per_page, total, total_pages } = res.data;
          setPage({ page, perPage: per_page, total, total_pages });
        })
        .catch(e => {
          enqueueSnackbar(`${intl.formatMessage({ id: 'ERROR' })}: ${getResponseMessage(e)}`, {
            variant: 'error',
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
    []
  );

  return { fetchOffers, loadingOffers, offers, page };
};
